import type { EmailField } from '@payloadcms/plugin-form-builder/types';
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form';

import { useTranslations } from 'next-intl';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FormFieldError } from '@/payload/blocks/form/components/error';
import { cn } from '@/utils/cn';

type EmailFieldProps = EmailField & {
  register: UseFormRegister<FieldValues>;
  errors: Partial<FieldErrorsImpl<{ [x: string]: unknown }>>;
};

export const Email: React.FC<EmailFieldProps> = ({
  required: requiredFromProps,
  defaultValue,
  register,
  errors,
  label,
  name,
}) => {
  const t = useTranslations('forms');

  return (
    <div className="w-full space-y-2">
      <Label htmlFor={name}>{label}</Label>

      <Input
        aria-describedby={errors[name] ? `${name}-error` : undefined}
        aria-invalid={Boolean(errors[name])}
        autoComplete="email"
        className={cn('min-h-12 w-full', errors[name] && 'border-red-300')}
        defaultValue={defaultValue}
        id={name}
        required={Boolean(requiredFromProps)}
        type="email"
        {...register(name, {
          pattern: {
            message: t('invalidEmail'),
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          },
          required: {
            message: t('required'),
            value: requiredFromProps || false,
          },
        })}
      />

      {errors[name] && (
        <FormFieldError id={`${name}-error`} message={String(errors[name]?.message || t('required'))} title={label} />
      )}
    </div>
  );
};
